import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'frodo-password-view',
  templateUrl: './password-view.component.html',
  styleUrls: ['./password-view.component.scss'],
})
export class PasswordViewComponent implements AfterViewInit {
  @Input() viewType: string;

  @Output() passwordSubmit = new EventEmitter<string>();

  @ViewChild('code') codeField: ElementRef;

  ngAfterViewInit(): void {
    this.codeField.nativeElement.focus();
  }
}
